import { InstalledAssetSubject, Message, Topic } from "@visioni/a3s-messages";
import { Json, Utf8 } from "@visioni/a3s-codecs";
import z from "zod/v4";

export const DeterrenceDevice = z.enum(["siren", "strobe"]);
export type DeterrenceDevice = z.output<typeof DeterrenceDevice>;

export const TriggerCommand = z.object({
  action: z.literal("trigger"),
  devices: DeterrenceDevice.array().nonempty(),
});

export const StopCommand = z.object({
  action: z.literal("stop"),
});

const DeterrenceCommandV1Schema = Message({
  typ: "DeterrenceCommand",
  ver: "1",
  sub: InstalledAssetSubject,
  dat: z.discriminatedUnion("action", [TriggerCommand, StopCommand]),
});

export const DeterrenceCommandV1 = Utf8(Json(DeterrenceCommandV1Schema));

export const DeterrenceCommandTopic = Topic.installedAsset("deterrence", "commands");
